<template lang="html">
<div>
     <div :class="['content-block',{'block2':compx==2}]">
           <div class="headttl">
                 <div class="head-line"></div>
<!--                 <div class="head-text">{{compx==1?2019:2018}}年</div>-->
               <div class="head-text" v-if="compx==6">2023年</div>
               <div class="head-text" v-if="compx==5">2022年</div>
               <div class="head-text" v-if="compx==4">2021年</div>
               <div class="head-text" v-if="compx==3">2020年</div>
               <div class="head-text" v-else-if="compx==1">2019年</div>
               <div class="head-text" v-else-if="compx==2">2018年</div>
           </div>
         <div v-for="(line,index) in inArr" :key="index" class="block-line">
             <div v-for="(item,x) in line" :key="x" :class="['item',{'i-add':item.iAdd}]" @click="goInner(item,compx)">
                 <div class="imgs">
                     <img :src="item.img" alt="">
                 </div>
                 <div class="item-text ellipsis">{{item.name}}</div>
             </div>
         </div>
     </div>
</div>
</template>

<script>
export default {
    props:['dataArr','compx'],
    watch:{
        dataArr:function(e){
            this.inArr = e;
            if(e[e.length - 1].length == 2){
                this.inArr[e.length - 1].push({
                     iAdd:true
                });
            }
        }
    },
    data(){
        return{
            inArr:[]
        }
    },
    methods:{
        goInner:function(e){
            if(e.name=='帝京景物略'){
                window.location.href='http://book.china1904.com/book_1'
            }else if(e.name=='西清古鑑'){
                window.location.href='http://book.china1904.com/book_2'
            }else{
                if(e.year=='2018'||e.year=='2019'||e.year=='2020'||e.year=='2021'){
                    this.push({
                        path:'album',
                        query:{
                            iab:e.id
                        }
                    })
                }else if(e.year=='2022'){
                    window.location.href="http://m.china1901.com/#/Album?id="+e.id
                }else if(e.year=='2023'){
                    window.location.href="http://m.china1901.com/#/Album?id="+e.id
                }
            }
        }
    },
    created:function(){
        // this.goInner();
    }
}
</script>

<style lang="css" scoped>

/*- 内容块 -*/

.headttl{
    height: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.head-line{
    height: 1px;
    background: #999999;
    width: 180px;
}

.headttl .head-text{
    padding: 0 12px;
    background: #efefef;
    margin-top: -12px;
    font-size: 14px;
}

.block-line{
    margin: 0 12px;
    margin-bottom: 9px;
    display: flex;
    justify-content: space-between;
}

.block-line .item{
    width: 109px;
    background: white;
}

.block-line .item.i-add{
   background:transparent;
}

.block-line .item .imgs{
    width: 109px;
    height: 109px;
    padding: 9px;
    box-sizing: border-box;
}

.block-line .item .imgs img{
    width: 100%;
    height: 100%;
}

.item .item-text{
    display: inline-block;
    font-size: 13px;
    width: 85px;
    margin: 0 12px;
    padding-bottom: 6px;
}

.block2 .item .imgs{
    height: 80px;
}

</style>
